import React from 'react';

export default function SkeletonCardV2() {
    return (
        <li className="skeleton-card-v2" aria-hidden="true">
            <div className="skeleton-card-v2__body">
                <div className="skeleton-card-v2__left">
                    <div className="skeleton-card-v2__top">
                        <div className="skeleton-card-v2__avatar" />
                        <div className="skeleton-card-v2__header-lines">
                            <div className="skeleton-card-v2__line skeleton-card-v2__line--header" />
                            <div className="skeleton-card-v2__line skeleton-card-v2__line--subheader" />
                        </div>
                    </div>
                    <div className="skeleton-card-v2__details">
                        <div className="skeleton-card-v2__detail-row">
                            <div className="skeleton-card-v2__dot" />
                            <div className="skeleton-card-v2__line skeleton-card-v2__line--detail-long" />
                        </div>
                        <div className="skeleton-card-v2__detail-row">
                            <div className="skeleton-card-v2__dot" />
                            <div className="skeleton-card-v2__line skeleton-card-v2__line--detail-short" />
                        </div>
                    </div>
                    <div className="skeleton-card-v2__chips">
                        <div
                            className="skeleton-card-v2__chip"
                            style={{minWidth: 168}}
                        >
                            <div className="skeleton-card-v2__chip-icon" />
                            <div className="skeleton-card-v2__chip-text" />
                            <div className="skeleton-card-v2__chip-icon" />
                        </div>
                        <div
                            className="skeleton-card-v2__chip"
                            style={{minWidth: 144}}
                        >
                            <div className="skeleton-card-v2__chip-text" />
                            <div className="skeleton-card-v2__chip-icon" />
                        </div>
                    </div>
                </div>
                <div className="skeleton-card-v2__right">
                    <div className="skeleton-card-v2__line skeleton-card-v2__line--address" />
                    <div className="skeleton-card-v2__button">
                        <div className="skeleton-card-v2__button-icon" />
                        <div className="skeleton-card-v2__button-text" />
                    </div>
                </div>
            </div>
        </li>
    );
}
